import React from 'react';
import styled from 'styled-components';
import Collapsible from '../Components/Collapsible';
import { breakpoint } from '../styling/mixins/breakpoints';
import { getColor } from '../styling/mixins/colors';
import { text } from '../styling/mixins/typography';
import { section } from '../styling/utils/grid';
import { EditorStringModel } from '../Types/EditorString';
import EditorString from '../Components/EditorString/EditorString';

interface FaqAccordionProps {
  systemId: string;
  title: string;
  faqItems: FaqAccordionItem[];
}

interface FaqAccordionItem {
  title?: string;
  text?: EditorStringModel;
}

const StyledFaqWrapper = styled.div`
  ${section}
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 2.4rem;
  padding-bottom: 2.4rem;

  ${breakpoint('medium')} {
    padding-top: 2.4rem;
    padding-bottom: 2.4rem;
  }
  ${breakpoint('large')} {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
`;

const StyledCollapsible = styled(Collapsible)`
  background-color: ${getColor('grey', 100)};
  max-width: 768px;
  width: 100%;

  &.collapsible {
    border: none;

    &:last-child {
      border: none;
    }

    &:not(:last-child) {
      margin-bottom: 0.8rem;
    }

    label {
      padding: 0.8rem 0.8rem 0.8rem 1.6rem;
    }

    .icon-wrapper {
      width: 40px;
      height: 40px;
      background-color: ${getColor('primary')};

      .icon {
        font-size: 2.4rem;
      }
    }

    .ReactCollapse--content {
      ${text('large')}
      padding: 1.6rem;
      background-color: ${getColor('white')};
      border: 1px solid ${getColor('grey', 100)};
      border-top: none;
    }
  }
`;

const FaqAccordion = (props: FaqAccordionProps) => {
  const faqList = props.faqItems;

  return (
    <StyledFaqWrapper>
      {faqList.map((faq) => (
        <StyledCollapsible key={faq.title} label={faq.title}>
          <EditorString value={faq.text?.value} />
        </StyledCollapsible>
      ))}
    </StyledFaqWrapper>
  );
};

export default FaqAccordion;
